// extracted by mini-css-extract-plugin
export default {"body":"PostBody_body__+Dc6E"};